import { Injectable } from '@angular/core';
import { Resolve, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import * as fromStore from '../store';
import { Store } from '@ngrx/store';

import { TRANSLATION_MODULES_SEARCH_PAGE,
		SESSION_VAR_KEY_LANGUAGE,
		DEFAULT_LANGUAGE
		} from '@ibe.config';

import * as UserActions from '@ibe/store/actions/user.actions';
import * as FlightsFilterActions from '@ibe/store/actions/flights-filter.actions';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { TimeoutSvcService } from '@ibe.services/timeout-svc.service';

@Injectable()
export class INDRABookingPaymentRedirectResolver implements Resolve<any> {

	constructor(
		private router: Router,
		private store: Store<fromStore.State>,
		private ibeAdminService: INDRAIbeAdminService,
		private storage: INDRAStorageService,
		private timeoutSvc: TimeoutSvcService
	) {}

	resolve(route: ActivatedRouteSnapshot, route_state: RouterStateSnapshot): Observable<any> {
		const observable = Observable.create(obs => { 
			obs.next(true);
			
			/*
			userInfo (user_info)
			promoCodesAndVoucher (promocodes_voucher)
			weakFlightsDiscount (weakflight_discount)
			bookedTrip (booked_trip)
			bookAwardFlights (book_award_flight)
			bookedTripExtras (booked_trip_extras)
			bookingSteps (booking_steps)
			searchRoute (search_route)
			starAllianceFlights (is_star_alliance_flight)
			*/
			
			this.ibeAdminService.loadTranslations('tap', TRANSLATION_MODULES_SEARCH_PAGE,
			(sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ? sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) : DEFAULT_LANGUAGE));

			const userInfo = this.storage.get('user_info');
			if (userInfo) {
				this.store.dispatch(new UserActions.PutLoggedInAction(true));
				this.store.dispatch(new UserActions.PutUserInfoAction(userInfo));
			}
			
			const bookAwardFlights = this.storage.get('book_award_flight');
			if (bookAwardFlights) {
				this.store.dispatch(new FlightsFilterActions.PutBookAwardFlights(bookAwardFlights));
			}
			
			const isStarAllianceFlight = this.storage.get('is_star_alliance_flight');
			if (isStarAllianceFlight) {
				this.store.dispatch(new FlightsFilterActions.PutStarAllianceFlights(isStarAllianceFlight));
			}
			
			this.timeoutSvc.startTimer();
			obs.complete();
			
		});
		
		
		return observable;
	}

}
